import { getLang } from "@/utils/storage";
import { getItem,removeItem } from '@/utils/storage-main.js'
import {isMobileWechat} from '@/utils'
import defaultAvatar from '@/assets/images/avatar.png'
import { getBusinessType } from '@/constant'
export const getCookie = function (name) {
  var arr
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) return unescape(arr[2])
  else return null
}

export const getLangSting = function (lang, en, cn) {
  // 有一个为null返回另一个
  if (!en) {
    return cn
  }
  if (!cn) {
    return en
  }
  // 去掉空格后为空返回另一个
  if (en.trim() === '') {
    return cn
  }
  if (cn.trim() === '') {
    return en
  }
  // 按照中英文
  return lang === 'en' ? en : cn
}


export const textToAvatar = (firstName, lastName) => {
  const colors = ['#3D75F7', '#7F39FD', '#00C5A9', '#FD962B', '#FF6E3B']
  let lastHasEnglish = lastName.search(/[A-Za-z]+/)
  let firstHasEnglish = firstName.search(/[A-Za-z]+/)
  let last =
    lastHasEnglish > -1
      ? lastName[lastHasEnglish].toUpperCase()
      : lastName.length > 1
      ? lastName.split('')[0] + lastName.split('')[1]
      : lastName
  let first =
    last.length > 1
      ? ''
      : firstHasEnglish > -1
      ? firstName[firstHasEnglish].toUpperCase()
      : firstName.length > 1
      ? firstName.split('')[0] + firstName.split('')[1]
      : firstName

  let name = first + last
  let fontWeight = 'normal'
  let fontSize = 60
  let canvas = ''
  if (document.getElementById('headImg')) {
    canvas = document.getElementById('headImg')
  } else {
    canvas = document.createElement('canvas')
    canvas.id = 'headImg'
    // canvas.style.display = 'none';
    // document.body.appendChild(canvas)
  }
  canvas.width = 120
  canvas.height = 120
  let context = canvas.getContext('2d')
  context.fillStyle = colors[Math.floor(Math.random() * colors.length)]
  context.fillRect(0, 0, canvas.width, canvas.height)
  context.fillStyle = '#fff'
  context.font = fontWeight + ' 40px sans-serif'
  context.textAlign = 'center'
  context.textBaseline = 'middle'
  context.fillText(name, fontSize, fontSize)
  return canvas.toDataURL('image/png')
}

export const getBase64Image =  (url) => {
  const img = new Image(120, 120)
  img.crossOrigin = 'Anonymous';
  img.src = url;
  return new Promise((resolve, reject) => {
      img.onload = () => {
          //canvas基本配置
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve({
              success: true,
              //canvas.toDataURL的方法将图片的绝对路径转换为base64编码
              base64: canvas.toDataURL()
          })
      }
      img.onerror = (e) => {
          reject({ success: e })
      }
  })
}

export const getLocalAvatarByUserInfo = async (userInfo) => {
  const lang = getLang()
  let { firstName, lastName } = userInfo
  // 姓或名 生成带姓和名的头像
  // 都没有走默认图
  if (!firstName && !lastName) {
    try {
    const {base64} = await getBase64Image(defaultAvatar)
    return base64
    } catch (error) {
      console.log(error)
    }
  } else {
    return lang === 'cn'
    ? textToAvatar(lastName, firstName)
    : textToAvatar(firstName, lastName);
  }
}

export const dataURLtoBlob = (dataurl) => {
  var arr = dataurl.split(',');
  //注意base64的最后面中括号和引号是不转译的   
  var _arr = arr[1].substring(0, arr[1].length - 2);
  var mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(_arr),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
};


export const  saveExpireTime = (now, expire_in,expireRatio) => {
  const expireTime = now + expire_in * 1000 * expireRatio
  localStorage.setItem('expired_time', expireTime)
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export function judegeUrlSpliceCharacter (url) {
  if (url) {
    return url.indexOf('?') === -1 ? '?' : '&'
  }
}

export function validURl (url) {
  const urlTest = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/
  return urlTest.test(url)
}

export function getDefaultAuthPrefix () {
  return `token=${getItem('Authorization')}&refresh_token=${getItem('refresh_token')}&expired_time=${getItem('expired_time')}`
}

export function genfinalUrl (url) {
  const and = judegeUrlSpliceCharacter(url)
  const { hannels } = param2Obj(window.location.href)
  if (getBusinessType()?.isNeedPassSource) {
    return `${url}${and}${getDefaultAuthPrefix()}${hannels ? `&hannels=${hannels}` : ''}`
  }
  const nowehcat = `${url}${and}${getDefaultAuthPrefix()}`
  return isMobileWechat() ? `${nowehcat}&openid=${getItem('open_id')}` : nowehcat
}

export function successJump(url) {
  // window.location.href = url || `${process.env.VUE_APP_HOME}?${getDefaultAuthPrefix()}`
  const jump_url = url || `${process.env.VUE_APP_HOME}?${getDefaultAuthPrefix()}`

  window.location.replace(jump_url)
}

// 是否为旧的eventId
export function isOldEventId (eventId) {
  return eventId && eventId.indexOf('-') !== -1;
}


// 删除 url 中的参数
export function deleteUrlParam(url, filterParams) {
  const index = url.indexOf('?')
  const params = url.substring(index + 1).split('&')
  const prefix = url.substring(0, url.indexOf('?'))
  let suffix = ''

  for (let i = params.length - 1; i >= 0; i--) {
    let param = params[i]
    let key = param && param.split('=', 2)[0]

    if (!param || filterParams.indexOf(key) !== -1) {
      params.splice(i, 1)
    }
  }

  if (params.length) {
    suffix = (prefix ? '?' : '') + params.join('&')
  }

  const newUrl = prefix + suffix

  return newUrl
}

// 获取所有参数
export function getAllUrlParams() {
  const params = param2Obj(window.location.href)
  const redirectParams = param2Obj(params.redirect_url || '')

  return { ...params, ...redirectParams }
}

// 设置多余参数
export function setExtraParams() {
  let extraParams = ''
  const allParamsMap = getAllUrlParams()

  const ignoreParams = [
    'customerId',
    'hide',
    'lang',
    'name',
    'redirect_url',
    'enter',
  ]

  for (const key in allParamsMap) {
    const value = allParamsMap[key]
    const isExtraParams =
      !ignoreParams.includes(key) && value && !extraParams?.includes(key)

    if (isExtraParams) {
      extraParams = `${extraParams}&${key}=${value}`
    }
  }

  localStorage.setItem('extraParams', extraParams)
}